const MuiButtonGroup = {
    defaultProps: {
        disableElevation: true,
        variant: 'contained',
        size: 'small'
    }
};
export { MuiButtonGroup };

//# sourceMappingURL=button-group.js.map